import React from 'react';

// The flat Kaaba: shown first while the 3D logo loads, and where WebGL can't run.
// Kept in its own file so it never pulls three.js into the main bundle.
export const KaabaIcon = ({ size = 64 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="Kaaba">
        {/* top */}
        <path d="M32 10 L54 21 L32 32 L10 21 Z" fill="#2b2b2b" />
        {/* left face */}
        <path d="M10 21 L32 32 L32 56 L10 45 Z" fill="#111" />
        {/* right face */}
        <path d="M54 21 L32 32 L32 56 L54 45 Z" fill="#1c1c1c" />
        {/* gold band (kiswah) */}
        <path d="M10 26 L32 37 L32 41 L10 30 Z" fill="#D4AF37" />
        <path d="M54 26 L32 37 L32 41 L54 30 Z" fill="#C9A227" />
        {/* door */}
        <path d="M38 41 L44 38 L44 46 L38 49 Z" fill="#D4AF37" />
    </svg>
);

export default KaabaIcon;
